
        <ng-container *ngIf="moduleAvailable$ | async; else notAvailable">
            <div class="tw-mb-4">
                <h2 class="tw-mb-1">{{ name }}</h2>
                <ng-container *ngIf="isTemplate(description); else text">
                    <ng-container *ngTemplateOutlet="description"></ng-container>
                </ng-container>
                <ng-template #text>
                    <p class="tw-m-0 tw-text-gray-500">{{ description }}</p>
                </ng-template>
            </div>
            <div *ngIf="navigation.length" class="tw-mb-4 tw-flex tw-gap-2 tw-flex-wrap">
                <button
                    *ngFor="let item of navigation"
                    nz-button
                    nzType="link"
                    routerLinkActive="ro-selected"
                    [routerLink]="item.url"
                    hoverClass="ro-hover-selected"
                >
                    <i *ngIf="item.iconClass" nz-icon [nzType]="item.iconClass" nzTheme="outline"></i>
                    {{ item.label }}
                </button>
            </div>
            <nz-divider class="tw-my-4"></nz-divider>
            <div>
                <router-outlet></router-outlet>
                <ng-content></ng-content>
            </div>
        </ng-container>
        <ng-template #notAvailable>
            <nz-result
                nzStatus="500"
                nzTitle="503"
                nzSubTitle="Disculpa, el contenido no está disponible en este momento."
            >
            </nz-result>
        </ng-template>
    